/*
 * This file is part of ng2-json-editor.
 * Copyright (C) 2016 CERN.
 *
 * ng2-json-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * ng2-json-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with ng2-json-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
*/

import { Injectable, TemplateRef } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';

import { CategorizedValidationProblems, SchemaValidationProblems, ValidationProblem, JsonEditorConfig } from '../interfaces';


export class AppGlobalsService {

  readonly adminMode$ = new ReplaySubject<boolean>(1);
  activeTabName = '';
  tabNameToFirstTopLevelElement: { [tabName: string]: string } = {};
  templates: {
    [templateName: string]: TemplateRef<any>,
    patchesHeaderTemplate?: TemplateRef<any>,
  } = {};
  config: JsonEditorConfig;
  private _adminMode = false;

  set adminMode(adminMode: boolean) {
    this._adminMode = adminMode;
    this.adminMode$.next(this._adminMode);
  }

  get adminMode() {
    return this._adminMode;
  }

  get firstElementPathForCurrentTab() {
    return this.tabNameToFirstTopLevelElement[this.activeTabName];
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
